import React, { useState } from "react";
import { 
  CheckBadgeIcon, 
  XCircleIcon, 
  ClockIcon, 
  UserCircleIcon 
} from "@heroicons/react/24/solid";

export default function PartenaireCard({ partenaire, onClick }) {
  const [isHovered, setIsHovered] = useState(false);

  // Déterminer l'icône et la couleur en fonction du statut conformité
  const getStatusIcon = (statut) => {
    switch (statut) {
      case "Actif":
        return { icon: <CheckBadgeIcon className="h-6 w-6 text-white" />, bgColor: "bg-green-500" };
      case "Inactif":
        return { icon: <XCircleIcon className="h-6 w-6 text-white" />, bgColor: "bg-red-500" };
      case "Onboarding":
        return { icon: <ClockIcon className="h-6 w-6 text-white" />, bgColor: "bg-orange-500" };
      default:
        return { icon: null, bgColor: "" }; // Pas d'icône si le statut est inconnu
    }
  };

  const { icon, bgColor } = getStatusIcon(partenaire.statutConformite);

  return (
    <div 
      className="relative z-10 bg-white rounded-lg shadow-md p-4 cursor-pointer border border-gray-200 transition-all hover:shadow-lg overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Icône de statut conformité en haut à droite */}
      {icon && (
        <div className={`absolute top-2 right-2 p-2 rounded-full ${bgColor}`}>
          {icon}
        </div>
      )}

      {/* Logo ou icône par défaut */}
      <div className="flex justify-center">
        {partenaire.logo ? (
          <img 
            src={partenaire.logo} 
            alt="Logo" 
            className="h-16 w-16 object-contain"
          />
        ) : (
          <UserCircleIcon className="h-16 w-16 text-gray-400" />
        )}
      </div>

      {/* Nom de la société */}
      <h3 className="text-center text-lg font-semibold mt-3 text-gray-800">
        {partenaire.nom_societe}
      </h3>

      {/* Classe d’actifs */}
      <p className="text-center text-sm text-gray-600 mt-1">
        {partenaire.classe_actifs}
      </p>

      {/* Nom du référent */}
      <p className="text-center text-gray-800 font-medium mt-2">
        {partenaire.nom_referent || "Référent inconnu"}
      </p>

      {/* Sous-section qui apparaît au survol */}
      <div 
        className={`absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white text-center p-3 transition-all duration-300 ${
          isHovered ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
        }`}
      >
        <button 
          className="bg-white text-black font-semibold px-4 py-2 rounded-lg hover:bg-gray-200 transition"
          onClick={() => onClick(partenaire)}
        >
          En savoir plus
        </button>
      </div>
    </div>
  );
}
